import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { MenuComponent } from './menu/menu.component';
import { AppRoutingModule } from 'src/app/app-routing.module';
import { ProfileModule } from 'src/app/pages/profile/profile.module';


@NgModule({
  declarations: [
    HeaderComponent,
    FooterComponent,
    MenuComponent,
  ],
  imports: [
    CommonModule,
    AppRoutingModule,
    ProfileModule

  ],
  exports:[
    HeaderComponent,
    FooterComponent,
    MenuComponent
  ]
})
export class GeneralModule { }
